import { ApiCore } from '../apis/utils/core';
import type { getMeetingRooms } from './meetingRooms';

type LegacyMeetingRoom = {
  id: number;
  name: string;
  url: string;
  description: string | null;
};

const legacyMeetingRoomApi = new ApiCore({
  getAll: true,
  getSingle: false,
  post: false,
  put: false,
  patch: false,
  remove: false,
  singleExtra: false,
  url: 'MeetingRooms',
});

export const getLegacyMeetingRooms = async (): ReturnType<typeof getMeetingRooms> => {
  const legacyMeetingRooms = await legacyMeetingRoomApi.getAll<LegacyMeetingRoom[]>();
  if (!legacyMeetingRooms) {
    return {
      error: {
        status: 'error',
        error: {
          httpStatus: 400,
          code: 'BAD_REQUEST',
          details: {
            issues: {
              paramsResult: null,
              headersResult: null,
              queryResult: null,
              bodyResult: null,
            },
          },
        },
      },
      response: {} as Response,
    };
  }

  return {
    data: {
      status: 'success',
      data: legacyMeetingRooms.map(mr => {
        return {
          id: mr.id,
          name: mr.name,
          url: mr.url,
          description: mr.description,
          isActive: true,
        };
      }),
      metadata: {
        pagination: {
          totalCount: legacyMeetingRooms.length,
          offset: 0,
          limit: legacyMeetingRooms.length,
        },
      },
    },
    response: {} as Response,
  };
};
